import { useTenantSettings } from 'react-common'

export const useIsLearnerDashboardEnabled = () => {
  const setting = useTenantSettings<{ enabled: boolean }>('learner.dashboard', true)

  return setting?.enabled
}
